// ============================================================================
// JOHNSON - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'johnson',
  name: 'Johnson',
  category: 'Graphs',
  complexity: {
    time: 'O(V² log V + VE)',
    space: 'O(V²)'
  },
  description: 'An all-pairs shortest path algorithm that works with sparse graphs containing negative edge weights. It uses Bellman-Ford to reweight edges and then runs Dijkstra from each vertex.'
};
